import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Divider,
} from '@mui/material';
import { motion } from 'framer-motion';

const destinations = [
  {
    title: 'Gibraltar',
    description: 'Gibraltar je britské zámořské území na jihu Pyrenejského poloostrova. Je známý především svou ikonickou skálou, která je domovem opic makaků magot. Návštěvníci mohou vystoupat na vrchol skály lanovkou a užít si nádherný výhled na Středozemní moře a Afriku. V Gibraltaru najdete také jeskyně, podzemní tunely a historické památky.',
    image: '/images/gibraltar.webp',
    tips: [
      'Navštivte opice makaky magoty na vrcholu skály',
      'Prohlédněte si jeskyně St. Michael\'s Cave',
      'Projděte se po Main Street a nakupujte v bezcelních obchodech',
      'Navštivte Great Siege Tunnels z 18. století',
    ],
  },
  {
    title: 'Casares',
    description: 'Casares je malebné bílé andaluské město, které se tyčí na úbočí hory. Je známé svými úzkými uličkami, bílými domy a nádhernými výhledy na okolní krajinu. Město má bohatou historii sahající až do římských dob a je považováno za jedno z nejkrásnějších "pueblos blancos" v Andalusii.',
    image: '/images/cassares.jpg',
    tips: [
      'Projděte se úzkými uličkami historického centra',
      'Navštivte hrad Casares s výhledem na okolí',
      'Vyfotografujte si typické bílé domy a květinové balkony',
      'Ochutnejte místní speciality v restauracích s terasami',
    ],
  },
  {
    title: 'Ronda',
    description: 'Ronda je jedno z nejpůsobivějších měst v Andalusii, známé především svým mostem Puente Nuevo, který překlenuje hluboký kaňon El Tajo. Město je rozděleno na starou a novou část a nabízí návštěvníkům kombinaci historie, přírody a kultury.',
    image: '/images/Ronda.jpg',
    tips: [
      'Prohlédněte si ikonický most Puente Nuevo a kaňon El Tajo',
      'Navštivte nejstarší španělskou arénu pro býčí zápasy',
      'Projděte se po starém městě a objevte arabské lázně',
      'Vychutnejte si místní víno a tapas v tradičních restauracích',
    ],
  },
];

const Surroundings: React.FC = () => {
  return (
    <Box sx={{ py: 8, bgcolor: 'background.default' }}>
      <Container>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Typography 
            variant="h3" 
            component="h1" 
            gutterBottom 
            align="center" 
            sx={{ mb: 1 }}
          >
            Okolí a tipy na výlety
          </Typography>
          <Typography 
            variant="h6" 
            color="text.secondary" 
            align="center" 
            sx={{ mb: 6 }}
          >
            Objevte krásy Costa del Sol a okolí
          </Typography>

          <Grid container spacing={4}>
            {destinations.map((destination, index) => (
              <Grid item xs={12} key={destination.title}>
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                >
                  <Card 
                    sx={{ 
                      display: 'flex',
                      flexDirection: { xs: 'column', md: 'row' },
                      borderRadius: 2,
                      overflow: 'hidden',
                      boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                      transition: 'transform 0.3s ease-in-out',
                      '&:hover': {
                        transform: 'translateY(-8px)',
                      },
                    }}
                  >
                    <CardMedia
                      component="img"
                      sx={{ 
                        width: { xs: '100%', md: '40%' },
                        height: { xs: 200, md: 'auto' },
                      }}
                      image={destination.image}
                      alt={destination.title}
                    />
                    <CardContent sx={{ flex: 1, p: 3 }}>
                      <Typography 
                        gutterBottom 
                        variant="h4" 
                        component="h2"
                        sx={{ fontWeight: 600 }}
                      >
                        {destination.title}
                      </Typography>
                      <Typography 
                        variant="body1" 
                        color="text.secondary"
                        sx={{ mb: 2 }}
                      >
                        {destination.description}
                      </Typography>
                      <Divider sx={{ my: 2 }} />
                      <Typography 
                        variant="h6" 
                        sx={{ mb: 1, fontWeight: 500 }}
                      >
                        Tipy na výlet:
                      </Typography>
                      <Box component="ul" sx={{ pl: 2 }}>
                        {destination.tips.map((tip, tipIndex) => (
                          <Typography 
                            component="li" 
                            key={tipIndex}
                            variant="body1"
                            sx={{ mb: 1 }}
                          >
                            {tip}
                          </Typography>
                        ))}
                      </Box>
                    </CardContent>
                  </Card>
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </motion.div>
      </Container>
    </Box>
  );
};

export default Surroundings; 